import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createBulletList = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): BulletListInterface => {
  const entity: BulletListInterface = {
    ...generateBaseEntity(EntityTypeEnum.BulletList, parentId, masterBlockId),
    type: EntityTypeEnum.BulletList,
    content:
      '<ul><li>Lorem ipsum dolor sit amet</li><li>Lorem ipsum dolor sit amet</li><li>Lorem ipsum dolor sit amet</li></ul>',
    textAlign: 'left',
    padding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    margin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 30,
      marginRight: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 10,
      marginRight: 0,
    },
    fontSize: 20,
    mobileFontSize: 18,
    lineHeight: 34,
    mobileLineHeight: 28,

    listItemIconColor: 'rgba(20, 158, 252, 1)',
    listItemIconSize: 20,
    listItemClassName: 'fas fa-check',
  }

  return entity
}
